<template>
    <AppView>
        <TopNav slot="top-app-view" title="Self Mentorship" title-class="lg:ml-body lg-app:tw-font-bold" center-title
            type="menu" @input="openSideNav()" show-notification-icon />
        <div class="px-body tw-pb-10 tw-mb-4 tw-pt-8 my-bg-pattern tw-mx-auto">
            <h3 class="tw-text-center opacity-54 tw-mt-2 tw-text-base leading-19">
                Welcome {{ userName || '' }}
            </h3>
            <h5 class="tw-text-center opacity-54 tw-text-xl leading-24 tw-mt-1 font-title">
                Available Modules
            </h5>
        </div>

        <transition mode="out-in" name="fade" appear>
            <ContentLoadingUserList v-if="loading" class="tw-mt-12" />
            <div v-else-if="!loading && !hasModules" class="c tw-py-24 tw-text-center">
                <h3 class="font-title tw-text-2xl tw-leading-tight tw-font-bold opacity-54 tw-mb-4">
                    You have no ongoing module
                </h3>
            </div>
            <template v-else>
                <transition name="new" mode="out-in" appear>
                    <div class="tw-overflow-x-visible mx-body mt-5 py-5">
                        <div class="tw-flex tw-justify-between tw-my-3">
                            <h6 class="opacity-54 tw-text-sm lg:tw-text-lg lg:tw-font-bold">My Modules</h6>
                        </div>
                        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
                            <div class="tw-col-span-12">
                                <SelfMentorshipModules :modules="sortedModules" :activeModuleId="activeModule?.id" />
                            </div>
                        </div>
                    </div>
                </transition>
            </template>
        </transition>
    </AppView>
</template>

<script>
import { mapState } from 'vuex';
import ContentLoadingUserList from '@/components/ContentLoadingUserList.vue';
// import EndedModules from '@/components/EndedModules.vue';
// import ActiveModuleCard from "@/components/ActiveModuleCard.vue";
import SelfMentorshipModules from '@/components/SelfMentorshipModules.vue';

export default {
    name: 'SelfMentorship',
    components: {
        ContentLoadingUserList,
        // EndedModules,
        // ActiveModuleCard,
        SelfMentorshipModules
    },

    data() {
        return {
            loading: true,
            modulesError: undefined,
            sortedModules: [],
        };
    },
    async created() {
        this.$store.commit('isFlatView', false);
        const dispatchName = 'getSelfMentorshipProgramModules';
        this.$store
            .dispatch(dispatchName, [])
            .then((sortedModules) => {
                this.sortedModules = sortedModules;
            })
            .catch((err) => {
                console.error('Error in getting mentee modules ', err);
                this.modulesError = 'Error in getting your modules';
            })
            .finally(() => {
                this.loading = false;
            });
    },
    computed: {
        ...mapState({
            userName: (state) => state.user.name || '',
        }),
        hasModules() {
            return this.sortedModules && this.sortedModules?.length > 0;
        },
    },
    methods: {
        /**
         * Returns the single active module if available,
         * or the first of multiple active ones (the next upcoming).
         */
        activeModule() {
            return this.sortedModules[0];
        },
    },
};

</script>
